export default __webpack_public_path__ + "static/media/barcode.bcd18493.png";